var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryParcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4261 5.38989L12.1761 1.95239C12.0838 1.90162 11.9801 1.875 11.8748 1.875C11.7695 1.875 11.6658 1.90162 11.5736 1.95239L5.32356 5.38989C5.22556 5.44385 5.14385 5.52311 5.08694 5.61941C5.03002 5.71572 5 5.82553 5 5.93739C5 6.04926 5.03002 6.15907 5.08694 6.25537C5.14385 6.35168 5.22556 6.43094 5.32356 6.48489L11.2498 9.74427V16.4436L9.35231 15.3999L8.74981 16.4943L11.5736 18.0474C11.6658 18.0982 11.7695 18.1248 11.8748 18.1248C11.9801 18.1248 12.0838 18.0982 12.1761 18.0474L18.4261 14.6099C18.5241 14.556 18.6058 14.4767 18.6628 14.3804C18.7197 14.2841 18.7498 14.1743 18.7498 14.0624V5.93739C18.7498 5.82551 18.7197 5.71568 18.6628 5.61938C18.6058 5.52307 18.5241 5.44382 18.4261 5.38989ZM11.8748 3.21364L16.8279 5.93739L11.8748 8.66114L6.92168 5.93739L11.8748 3.21364ZM17.4998 13.693L12.4998 16.443V9.74364L17.4998 6.99364V13.693Z",
    fill: "#94A3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10H1.25V8.75H6.25V10ZM7.5 15H2.5V13.75H7.5V15ZM8.75 12.5H3.75V11.25H8.75V12.5Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryParcel);
export default __webpack_public_path__ + "static/media/delivery-parcel.2dfa63dd15ba80629384c20d78563dde.svg";
export { ForwardRef as ReactComponent };